import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.account');
import { OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Chart from 'chart.js/auto';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-account',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.account/view.scss */
/* src/app/page.account/view.scss: no such file or directory */`],
})
export class PageAccountComponent implements OnInit, OnDestroy {
    public activeTab: string = 'profile';
    public mobileMainMenuOpen: boolean = false;
    public mobileMainMenuRect: any = null;
    public loading: boolean = true;
    public profileSaving: boolean = false;
    public passwordSaving: boolean = false;
    public activityLoading: boolean = false;
    public activityExporting: boolean = false;
    public activityRankingLoading: boolean = false;
    public hasPassword: boolean = true;
    public user: any = {};
    public profile: any = this.blankProfile();
    public password: any = this.blankPassword();
    public activityDashboard: any = null;
    public activityWeekStart: string = '';
    public activityError: string = '';
    public activityRankingDashboard: any = null;
    public activityRankingWeekStart: string = '';
    public activityRankingError: string = '';
    public activityGuidelineLoading: boolean = false;
    public activityGuidelineDashboard: any = null;
    public activityGuidelineWeekStart: string = '';
    public activityGuidelineError: string = '';
    public codexUsageLoading: boolean = false;
    public codexUsageRefreshing: boolean = false;
    public codexUsageLoaded: boolean = false;
    public codexUsageError: string = '';
    public codexAccounts: any[] = [];
    public codexAccountUsageOpen: boolean = false;
    public codexAccountUsageLoading: boolean = false;
    public selectedCodexAccount: any = null;
    public codexAccountUsageDashboard: any = {
        account: { label: '', email: '', name: '', plan: '', organization: '', status: '', last_checked: '' },
        period: { start: '', end: '', label: '', timezone: 'UTC+9' },
        totals: {
            requests: 0,
            success_requests: 0,
            error_requests: 0,
            duration_seconds: 0,
            duration_label: '0분',
            status_snapshots: 0,
            status_hours: 0,
            status_days: 0,
            current_remaining_weekly: ''
        },
        chart: { hours: [], days: [] }
    };
    private chartInstances: any = {};
    private chartRenderTimer: any = null;
    private readonly accountTabStorageKey: string = 'reviewops.account.active-tab.v1';
    private readonly accountTabs: string[] = ['profile', 'codex', 'activity', 'ranking', 'guide'];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/login');
        this.activeTab = this.initialTab();
        await this.load();
    }

    public ngOnDestroy() {
        if (this.chartRenderTimer) {
            clearTimeout(this.chartRenderTimer);
            this.chartRenderTimer = null;
        }
        this.destroyCharts();
    }

    public initialTab() {
        try {
            const params = new URLSearchParams(location.search || '');
            const tab = params.get('tab') || String(location.hash || '').replace('#', '');
            if (this.isKnownAccountTab(tab)) return tab;
            const savedTab = this.loadSavedAccountTab();
            return this.isKnownAccountTab(savedTab) ? savedTab : 'profile';
        } catch (e) {
            return 'profile';
        }
    }

    private isKnownAccountTab(tab: string) {
        return this.accountTabs.includes(String(tab || ''));
    }

    private loadSavedAccountTab() {
        try {
            return window.sessionStorage.getItem(this.accountTabStorageKey) || '';
        } catch (e) {
            return '';
        }
    }

    private saveAccountTab(tab: string) {
        if (!this.isKnownAccountTab(tab)) return;
        try {
            window.sessionStorage.setItem(this.accountTabStorageKey, tab);
        } catch (e) { }
    }

    private accountTabUrl(tab: string) {
        return tab === 'profile' ? '/account' : `/account?tab=${encodeURIComponent(tab)}`;
    }

    public blankProfile() {
        return {
            name: '',
            display_name: '',
            email: '',
            mobile: '',
            role: 'user'
        };
    }

    public blankPassword() {
        return {
            current_password: '',
            new_password: '',
            confirm_password: ''
        };
    }

    public syncProfile(user: any) {
        this.user = user || {};
        this.profile = {
            name: this.user.name || '',
            display_name: this.user.display_name || this.user.name || '',
            email: this.user.email || '',
            mobile: this.user.mobile || '',
            role: this.user.role || 'user'
        };
        if (this.activeTab === 'codex' && !this.showCodexUsageTab()) {
            this.activeTab = 'profile';
        }
        if (['activity', 'ranking', 'guide'].includes(this.activeTab) && !this.showActivityDashboard()) {
            this.activeTab = 'profile';
        }
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call('load');
        if (code === 200) {
            this.syncProfile(data.user);
            this.hasPassword = !!data.has_password;
            this.saveAccountTab(this.activeTab);
            await this.updateTabUrl(this.activeTab);
            await this.loadCurrentTab(false);
        } else {
            await this.service.modal.error(data.message || '계정 정보를 불러오지 못했습니다.');
        }

        this.loading = false;
        await this.service.render();
    }

    public async setTab(tab: string) {
        if (tab === 'codex' && !this.showCodexUsageTab()) return;
        if (['activity', 'ranking', 'guide'].includes(tab) && !this.showActivityDashboard()) return;
        this.activeTab = tab;
        this.saveAccountTab(tab);
        this.mobileMainMenuOpen = false;
        this.mobileMainMenuRect = null;
        if (tab === 'codex' && !this.codexUsageLoaded) this.codexUsageLoading = true;
        if (tab === 'activity' && !this.activityDashboard) this.activityLoading = true;
        if (tab === 'ranking' && !this.activityRankingDashboard) this.activityRankingLoading = true;
        if (tab === 'guide' && !this.activityGuidelineDashboard) this.activityGuidelineLoading = true;
        await this.updateTabUrl(tab);
        await this.service.render();
        await this.loadCurrentTab();
    }

    public async updateTabUrl(tab: string) {
        const url = this.accountTabUrl(tab);
        try {
            if (this.router && this.router.url !== url) {
                await this.router.navigateByUrl(url, { replaceUrl: true });
                return;
            }
        } catch (e) { }
        if (typeof history === 'undefined') return;
        try {
            history.replaceState(null, '', url);
        } catch (e) { }
    }

    public availableAccountTabs() {
        const tabs: string[] = ['profile'];
        if (this.showCodexUsageTab()) tabs.push('codex');
        if (this.showActivityDashboard()) tabs.push('activity', 'ranking', 'guide');
        return tabs;
    }

    public accountTabLabel(tab: string) {
        if (tab === 'profile') return '기본정보';
        if (tab === 'codex') return 'OpenAI 사용량';
        if (tab === 'activity') return '활동성';
        if (tab === 'ranking') return '활동성 랭킹';
        if (tab === 'guide') return '활동성 가이드라인';
        return tab;
    }

    public mobileAccountTabLabel(tab: string) {
        if (tab === 'profile') return '기본';
        if (tab === 'codex') return '에이전트';
        if (tab === 'ranking') return '랭킹';
        if (tab === 'guide') return '가이드';
        return this.accountTabLabel(tab);
    }

    public mobilePrimaryAccountTabs() {
        const available = this.availableAccountTabs();
        const ordered: string[] = [];
        const add = (tab: string) => {
            if (available.includes(tab) && !ordered.includes(tab)) ordered.push(tab);
        };
        add('profile');
        add('codex');
        add(this.activeTab);
        available.forEach((tab) => add(tab));
        return ordered.length > 4 ? ordered.slice(0, 3) : ordered.slice(0, 4);
    }

    public mobileOverflowAccountTabs() {
        const primary = this.mobilePrimaryAccountTabs();
        return this.availableAccountTabs().filter((tab) => !primary.includes(tab));
    }

    public mobileMainGridClass() {
        const primary = this.mobilePrimaryAccountTabs();
        const count = primary.length + (this.mobileOverflowAccountTabs().length ? 1 : 0);
        const columns = count <= 2 ? 'grid-cols-2' : count === 3 ? 'grid-cols-3' : 'grid-cols-4';
        return `reviewops-mobile-main-menu grid w-full ${columns} gap-1 xl:hidden`;
    }

    public mobileMainTabClass(tab: string) {
        const base = 'flex h-9 min-w-0 items-center justify-center rounded-md px-2 text-center text-[12px] font-semibold transition-colors ';
        if (this.activeTab === tab) return base + 'bg-slate-950 text-white shadow-sm';
        return base + 'text-slate-500 hover:bg-slate-100 hover:text-slate-900';
    }

    public mobileMainMoreButtonClass() {
        const base = 'flex h-9 w-full min-w-0 items-center justify-center gap-1 rounded-md px-2 text-[12px] font-semibold transition-colors ';
        if (this.mobileMainMenuOpen) return base + 'bg-slate-950 text-white shadow-sm';
        return base + 'text-slate-500 hover:bg-slate-100 hover:text-slate-900';
    }

    public mobileMainMenuStyle() {
        const width = 170;
        const margin = 8;
        const viewportWidth = Math.max((typeof window !== 'undefined' ? window.innerWidth : 0) || document.documentElement.clientWidth || width + (margin * 2), width + (margin * 2));
        const viewportHeight = Math.max((typeof window !== 'undefined' ? window.innerHeight : 0) || document.documentElement.clientHeight || 320, 320);
        const rect = this.mobileMainMenuRect || {};
        const rectRight = Number(rect.right || 0);
        const rectTop = Number(rect.top || 0);
        const rectBottom = Number(rect.bottom || 0);
        const overflowCount = Math.max(this.mobileOverflowAccountTabs().length, 1);
        const estimatedHeight = Math.min(320, 8 + (overflowCount * 36));
        const maxLeft = Math.max(margin, viewportWidth - width - margin);
        const left = Math.min(Math.max(margin, rectRight ? rectRight - width : maxLeft), maxLeft);
        let top = Math.max(margin, Math.round((rectBottom || 0) + margin));
        if (top + estimatedHeight > viewportHeight - margin && rectTop) {
            top = Math.max(margin, Math.round(rectTop - estimatedHeight - margin));
        }
        const maxHeight = Math.max(120, viewportHeight - top - margin);
        return { left: `${Math.round(left)}px`, top: `${Math.round(top)}px`, width: `${width}px`, maxHeight: `${maxHeight}px` };
    }

    public mobileOverflowTabClass(tab: string) {
        const base = 'block w-full px-3 py-2 text-left text-[13px] font-semibold transition-colors ';
        if (this.activeTab === tab) return base + 'bg-slate-950 text-white';
        return base + 'text-slate-600 hover:bg-slate-50 hover:text-slate-950';
    }

    public async toggleMobileMainMenu(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.mobileMainMenuOpen) {
            await this.closeMobileMainMenu();
            return;
        }
        this.mobileMainMenuRect = this.mobileMainMenuTriggerRect(event);
        this.mobileMainMenuOpen = true;
        await this.service.render();
    }

    public async closeMobileMainMenu(render: boolean = true) {
        if (!this.mobileMainMenuOpen && !this.mobileMainMenuRect) return;
        this.mobileMainMenuOpen = false;
        this.mobileMainMenuRect = null;
        if (render) await this.service.render();
    }

    public async selectMobileOverflowTab(tab: string, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.mobileMainMenuOpen = false;
        this.mobileMainMenuRect = null;
        await this.setTab(tab);
    }

    private mobileMainMenuTriggerRect(event?: Event) {
        const target: any = event ? ((event as any).currentTarget || event.target) : null;
        if (!target || !target.getBoundingClientRect) return null;
        const rect = target.getBoundingClientRect();
        return {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.width,
            height: rect.height
        };
    }

    public mainTabClass(tab: string) {
        const base = 'min-w-[70px] rounded-lg px-3 py-2 text-center text-[13px] transition-colors xl:min-w-[86px] xl:rounded-xl xl:px-5 xl:py-2.5 xl:text-[15px] ';
        if (this.activeTab === tab) return base + 'bg-slate-950 text-white shadow-sm';
        return base + 'text-slate-500 hover:text-slate-900';
    }

    public async loadCurrentTab(showBusy: boolean = true) {
        if (this.activeTab === 'activity' && !this.activityDashboard) {
            await this.loadActivityDashboard(showBusy);
        }
        if (this.activeTab === 'ranking' && !this.activityRankingDashboard) {
            await this.loadActivityRanking(showBusy);
        }
        if (this.activeTab === 'guide' && !this.activityGuidelineDashboard) {
            await this.loadActivityGuideline(showBusy);
        }
        if (this.activeTab === 'codex' && !this.codexUsageLoaded) {
            await this.loadCodexUsage(showBusy);
        }
    }

    public async loadActivityDashboard(showBusy: boolean = true) {
        if (!this.showActivityDashboard()) return;
        this.activityLoading = true;
        this.activityError = '';
        if (showBusy) await this.service.render();

        const { code, data } = await wiz.call('load_activity_dashboard', {
            user_activity_week_start: this.activityWeekStart || ''
        });
        if (code === 200) {
            this.activityDashboard = data.dashboard || null;
            this.activityWeekStart = this.activityDashboard && this.activityDashboard.period && this.activityDashboard.period.start
                ? this.activityDashboard.period.start
                : this.activityWeekStart;
        } else {
            this.activityDashboard = null;
            this.activityError = data.message || '사용자 활동 정보를 불러오지 못했습니다.';
        }

        this.activityLoading = false;
        if (showBusy) await this.service.render();
    }

    public async loadActivityRanking(showBusy: boolean = true) {
        if (!this.showActivityDashboard()) return;
        this.activityRankingLoading = true;
        this.activityRankingError = '';
        if (showBusy) await this.service.render();

        const { code, data } = await wiz.call('load_activity_ranking', {
            activity_ranking_week_start: this.activityRankingWeekStart || ''
        });
        if (code === 200) {
            this.activityRankingDashboard = data.dashboard || null;
            this.activityRankingWeekStart = this.activityRankingDashboard && this.activityRankingDashboard.period && this.activityRankingDashboard.period.start
                ? this.activityRankingDashboard.period.start
                : this.activityRankingWeekStart;
        } else {
            this.activityRankingDashboard = null;
            this.activityRankingError = data.message || '활동성 랭킹을 불러오지 못했습니다.';
        }

        this.activityRankingLoading = false;
        if (showBusy) await this.service.render();
    }

    public async loadActivityGuideline(showBusy: boolean = true) {
        if (!this.showActivityDashboard()) return;
        this.activityGuidelineLoading = true;
        this.activityGuidelineError = '';
        if (showBusy) await this.service.render();

        const { code, data } = await wiz.call('load_activity_guideline', {
            activity_guideline_week_start: this.activityGuidelineWeekStart || ''
        });
        if (code === 200) {
            this.activityGuidelineDashboard = data.dashboard || null;
            this.activityGuidelineWeekStart = this.activityGuidelineDashboard && this.activityGuidelineDashboard.period && this.activityGuidelineDashboard.period.start
                ? this.activityGuidelineDashboard.period.start
                : this.activityGuidelineWeekStart;
        } else {
            this.activityGuidelineDashboard = null;
            this.activityGuidelineError = data.message || '활동성 가이드라인을 불러오지 못했습니다.';
        }

        this.activityGuidelineLoading = false;
        if (showBusy) await this.service.render();
    }

    public async loadCodexUsage(showBusy: boolean = true) {
        if (!this.showCodexUsageTab()) return;
        this.codexUsageLoading = true;
        this.codexUsageError = '';
        if (showBusy) await this.service.render();

        const { code, data } = await wiz.call('load_codex_usage');
        if (code === 200) {
            this.codexAccounts = data.codex_accounts || [];
            this.codexUsageLoaded = true;
        } else {
            this.codexAccounts = [];
            this.codexUsageLoaded = false;
            this.codexUsageError = data.message || 'OpenAI 사용량 정보를 불러오지 못했습니다.';
        }

        this.codexUsageLoading = false;
        if (showBusy) await this.service.render();
    }

    public async refreshCodexUsage() {
        if (this.codexUsageRefreshing) return;
        this.codexUsageRefreshing = true;
        await this.service.render();
        await this.loadCodexUsage(false);
        this.codexUsageRefreshing = false;
        await this.service.render();
    }

    public async moveActivityWeek(direction: number) {
        const period = this.activityDashboard && this.activityDashboard.period ? this.activityDashboard.period : {};
        this.activityWeekStart = direction < 0 ? (period.previous_start || '') : (period.next_start || '');
        await this.loadActivityDashboard();
    }

    public async resetActivityWeek() {
        this.activityWeekStart = '';
        await this.loadActivityDashboard();
    }

    public activityHistoryExportUrl() {
        const params = new URLSearchParams();
        if (this.activityWeekStart) params.set('user_activity_week_start', this.activityWeekStart);
        const query = params.toString();
        return `/wiz/api/page.account/export_activity_history${query ? `?${query}` : ''}`;
    }

    public activityHistoryExportFileName() {
        const period = this.activityDashboard && this.activityDashboard.period ? this.activityDashboard.period : {};
        const start = String(period.start || this.activityWeekStart || '').replace(/[^\d]+/g, '');
        const end = String(period.end || '').replace(/[^\d]+/g, '');
        const userName = String(this.user.display_name || this.user.name || this.user.email || 'user').replace(/[\\/:*?"<>|]+/g, '-');
        return `${userName}-activity-history-${start || 'start'}-${end || 'end'}.xlsx`;
    }

    public activityExportResponseFileName(response: any) {
        const fallback = this.activityHistoryExportFileName();
        const header = String(response && response.headers ? response.headers.get('content-disposition') || '' : '');
        const encoded = /filename\*=UTF-8''([^;]+)/i.exec(header);
        if (encoded && encoded[1]) {
            try {
                return decodeURIComponent(encoded[1].replace(/"/g, '')).replace(/[\\/:*?"<>|]+/g, '-');
            } catch (e) { }
        }
        const quoted = /filename="?([^";]+)"?/i.exec(header);
        return String((quoted && quoted[1]) || fallback).replace(/[\\/:*?"<>|]+/g, '-');
    }

    public async exportActivityHistory() {
        if (this.activityExporting || this.activityLoading) return;
        this.activityExporting = true;
        await this.service.render();
        try {
            const response = await fetch(this.activityHistoryExportUrl(), { credentials: 'same-origin' });
            const contentType = String(response.headers.get('content-type') || '').toLowerCase();
            if (!response.ok || contentType.includes('application/json')) {
                let message = '활동 이력 Excel을 생성하지 못했습니다.';
                try {
                    const payload = await response.json();
                    message = (payload && payload.data && payload.data.message) || payload.message || message;
                } catch (e) { }
                await this.service.modal.error(message);
                return;
            }
            const blob = await response.blob();
            if (!blob || blob.size <= 0) {
                await this.service.modal.error('다운로드할 활동 이력 파일이 없습니다.');
                return;
            }
            const objectUrl = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = objectUrl;
            anchor.download = this.activityExportResponseFileName(response);
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
        } catch (e) {
            await this.service.modal.error('활동 이력 Excel을 생성하지 못했습니다.');
        } finally {
            this.activityExporting = false;
            await this.service.render();
        }
    }

    public async moveActivityRankingWeek(direction: number) {
        const period = this.activityRankingPeriod();
        this.activityRankingWeekStart = direction < 0 ? (period.previous_start || '') : (period.next_start || '');
        await this.loadActivityRanking();
    }

    public async resetActivityRankingWeek() {
        this.activityRankingWeekStart = '';
        await this.loadActivityRanking();
    }

    public async moveActivityGuidelineWeek(direction: number) {
        const period = this.activityGuidelinePeriod();
        this.activityGuidelineWeekStart = direction < 0 ? (period.previous_start || '') : (period.next_start || '');
        await this.loadActivityGuideline();
    }

    public async resetActivityGuidelineWeek() {
        this.activityGuidelineWeekStart = '';
        await this.loadActivityGuideline();
    }

    public activityRankingPeriod() {
        return this.activityRankingDashboard && this.activityRankingDashboard.period ? this.activityRankingDashboard.period : {};
    }

    public activityRankingUsers() {
        return this.activityRankingDashboard && Array.isArray(this.activityRankingDashboard.activity_users)
            ? this.activityRankingDashboard.activity_users
            : [];
    }

    public activityGuidelinePeriod() {
        return this.activityGuidelineDashboard && this.activityGuidelineDashboard.period ? this.activityGuidelineDashboard.period : {};
    }

    public activityGuidelineSummary() {
        return this.activityGuidelineDashboard && this.activityGuidelineDashboard.summary ? this.activityGuidelineDashboard.summary : {};
    }

    public activityGuidelinePersonal() {
        return this.activityGuidelineDashboard && this.activityGuidelineDashboard.personal ? this.activityGuidelineDashboard.personal : {};
    }

    public activityGuidelineRecommendation() {
        const personal = this.activityGuidelinePersonal();
        return personal && personal.recommendation ? personal.recommendation : { title: '', summary: '', actions: [] };
    }

    public activityGuidelineComparisonMetrics() {
        const personal = this.activityGuidelinePersonal();
        return personal && Array.isArray(personal.comparison_metrics) ? personal.comparison_metrics : [];
    }

    public activityGuidelinePriorityMetrics() {
        const personal = this.activityGuidelinePersonal();
        return personal && Array.isArray(personal.priority_metrics) ? personal.priority_metrics : [];
    }

    public activityGuidelineStrengthMetrics() {
        const personal = this.activityGuidelinePersonal();
        return personal && Array.isArray(personal.strength_metrics) ? personal.strength_metrics : [];
    }

    public activityGuidelineWeights() {
        return this.activityGuidelineDashboard && Array.isArray(this.activityGuidelineDashboard.score_weights)
            ? this.activityGuidelineDashboard.score_weights
            : [];
    }

    public activityGuidelineCoreWeights() {
        return this.activityGuidelineWeights().filter((item: any) => Number(item && item.weight || 0) > 10);
    }

    public activityGuidelineSupportWeights() {
        return this.activityGuidelineWeights().filter((item: any) => Number(item && item.weight || 0) <= 10);
    }

    public guidelineBoosts(item: any) {
        return item && Array.isArray(item.boosts) ? item.boosts : [];
    }

    public guidelinePrimaryBoost(item: any) {
        const boosts = this.guidelineBoosts(item);
        return boosts.length ? boosts[0] : ((item && item.guidance) || '');
    }

    public guidelineSecondaryBoosts(item: any) {
        return this.guidelineBoosts(item).slice(1, 3);
    }

    public guidelineImpactLabel(item: any) {
        return Number(item && item.weight || 0) > 10 ? '효과 큼' : '보조';
    }

    public activityGuidelineFocusMetrics() {
        return this.activityGuidelineDashboard && Array.isArray(this.activityGuidelineDashboard.focus_metrics)
            ? this.activityGuidelineDashboard.focus_metrics
            : [];
    }

    public activityGuidelineDirections() {
        return this.activityGuidelineDashboard && Array.isArray(this.activityGuidelineDashboard.directions)
            ? this.activityGuidelineDashboard.directions
            : [];
    }

    public activityGuidelineTraits() {
        if (!this.activityGuidelineDashboard) return [];
        if (Array.isArray(this.activityGuidelineDashboard.traits)) return this.activityGuidelineDashboard.traits;
        return Array.isArray(this.activityGuidelineDashboard.scenarios) ? this.activityGuidelineDashboard.scenarios : [];
    }

    public activityGuidelineScenarios() {
        return this.activityGuidelineTraits();
    }

    public activityGuidelineChecklist() {
        return this.activityGuidelineDashboard && Array.isArray(this.activityGuidelineDashboard.checklist)
            ? this.activityGuidelineDashboard.checklist
            : [];
    }

    public guidelineWeightBarWidth(weight: any) {
        return `${Math.max(4, Math.min(100, Number(weight || 0) * 2.5))}%`;
    }

    public guidelineScenarioClass(item: any) {
        const base = 'rounded-lg border p-4 transition';
        return item && item.is_current
            ? `${base} border-cyan-300 bg-cyan-50/70 shadow-sm`
            : `${base} border-slate-200 bg-white`;
    }

    public guidelineTraitClass(item: any) {
        return this.guidelineScenarioClass(item);
    }

    public guidelineDiffClass(item: any) {
        if (!item) return 'text-slate-500';
        if (item.status === 'above') return 'text-emerald-600';
        if (item.status === 'below') return 'text-rose-600';
        return 'text-slate-500';
    }

    public async saveProfile() {
        this.profileSaving = true;
        await this.service.render();

        const { code, data } = await wiz.call('save_profile', { data: JSON.stringify(this.profile) });
        this.profileSaving = false;
        if (code === 200) {
            this.syncProfile(data.user);
            this.hasPassword = !!data.has_password;
            this.service.auth.session = Object.assign({}, this.service.auth.session || {}, {
                name: data.user.name,
                display_name: data.user.display_name,
                email: data.user.email,
                role: data.user.role,
                can_use_project_catalog: data.user.can_use_project_catalog,
                can_create_project_catalog: data.user.can_create_project_catalog,
                can_browse_project_catalog: data.user.can_browse_project_catalog
            });
            await this.service.modal.success('내 정보가 저장되었습니다.');
        } else {
            await this.service.modal.error(data.message || '내 정보를 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async changePassword() {
        this.passwordSaving = true;
        await this.service.render();

        const { code, data } = await wiz.call('change_password', { data: JSON.stringify(this.password) });
        this.passwordSaving = false;
        if (code === 200) {
            this.hasPassword = !!data.has_password;
            this.password = this.blankPassword();
            await this.service.modal.success('비밀번호가 변경되었습니다.');
        } else {
            await this.service.modal.error(data.message || '비밀번호를 변경하지 못했습니다.');
        }
        await this.service.render();
    }

    public showCodexUsageTab() {
        return !!(this.user && this.user.has_codex_usage_access);
    }

    public showActivityDashboard() {
        const role = this.profile.role || this.user.role || '';
        return ['admin', 'internal'].includes(role);
    }

    public displayName() {
        return this.profile.display_name || this.profile.name || this.profile.email || 'User';
    }

    public initial() {
        return this.displayName().charAt(0);
    }

    public roleLabel(role: string) {
        const labels: any = {
            admin: '관리자',
            internal: '내부사용자',
            user: '사용자',
            guest: '손님'
        };
        return labels[role || 'user'] || role;
    }

    public kstDateTime(value: any) {
        return this.service.formatter.kstDateTime(value, '-');
    }

    public textValue(value: any) {
        if (value === null || value === undefined || value === '') return '';
        if (typeof value === 'object') {
            try {
                return JSON.stringify(value);
            } catch (e) {
                return '';
            }
        }
        return String(value);
    }

    public codexRouteLabel(value: any) {
        const route = String(value || '');
        if (route === 'local') return '로컬';
        if (route === 'proxy') return 'Proxy';
        if (route === 'direct') return '직접';
        return route || '-';
    }

    public codexAccountIdentity(row: any) {
        const account = row && row.account ? row.account : {};
        return account.email || row?.account_email || account.name || row?.account_name || row?.account_key || '-';
    }

    public codexAccountMeta(row: any) {
        const account = row && row.account ? row.account : {};
        const parts = [
            account.plan || row?.account_plan,
            this.codexRouteLabel(row?.route)
        ].filter((value: any) => !!value && value !== '-');
        return parts.length ? parts.join(' · ') : '계정 상세 없음';
    }

    public codexAccountProjects(row: any) {
        return Array.isArray(row && row.projects) ? row.projects : [];
    }

    public codexAccountProjectLabel(row: any) {
        const projects = this.codexAccountProjects(row)
            .map((project: any) => project && (project.name || project.id))
            .filter((value: any) => !!value);
        return projects.length ? projects.join(', ') : (row?.source_project_name || row?.source_project_id || '-');
    }

    public codexAccountStatusLabel(row: any) {
        const exitCode = Number(row && row.status_exit_code ? row.status_exit_code : 0);
        if (exitCode) return `실패 ${exitCode}`;
        return row && row.status ? row.status : '정상';
    }

    public codexAccountStatusClass(row: any) {
        const exitCode = Number(row && row.status_exit_code ? row.status_exit_code : 0);
        const status = String(row && row.status ? row.status : '').toLowerCase();
        const base = 'inline-flex shrink-0 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ';
        if (exitCode || status.includes('fail') || status.includes('error') || status.includes('expired')) return base + 'bg-rose-50 text-rose-700';
        if (!row || !row.last_checked) return base + 'bg-amber-50 text-amber-700';
        return base + 'bg-emerald-50 text-emerald-700';
    }

    public codexDefaultUsage(row: any) {
        return row && row.default_usage ? row.default_usage : {};
    }

    public codexUsagePercent(row: any) {
        const usage = this.codexDefaultUsage(row);
        return this.textValue(usage.remaining_weekly) || '-';
    }

    public codexUsageReset(row: any) {
        const usage = this.codexDefaultUsage(row);
        return this.textValue(usage.reset_weekly) || '-';
    }

    private codexAccountUsagePayload(row: any) {
        const account = row && row.account ? row.account : {};
        return {
            account_key: row?.account_key || '',
            account_id: row?.account_id || account.id || '',
            account_email: row?.account_email || account.email || '',
            account_name: row?.account_name || account.name || '',
            account_plan: row?.account_plan || account.plan || '',
            organization: row?.organization || account.organization || '',
            default_usage: this.codexDefaultUsage(row),
            account: {
                id: account.id || '',
                email: account.email || '',
                name: account.name || '',
                plan: account.plan || '',
                organization: account.organization || ''
            }
        };
    }

    public async openCodexAccountUsage(account: any) {
        if (!account) return;
        this.selectedCodexAccount = account;
        this.codexAccountUsageOpen = true;
        await this.loadCodexAccountUsage();
    }

    public async loadCodexAccountUsage() {
        if (!this.selectedCodexAccount) return;
        this.codexAccountUsageLoading = true;
        await this.service.render();

        const payload = this.codexAccountUsagePayload(this.selectedCodexAccount);
        const { code, data } = await wiz.call('load_codex_account_usage_dashboard', { data: JSON.stringify(payload) });
        if (code === 200) {
            this.codexAccountUsageDashboard = data.dashboard || this.codexAccountUsageDashboard;
        } else {
            this.codexAccountUsageOpen = false;
            this.selectedCodexAccount = null;
            await this.service.modal.error(data.message || 'OpenAI 계정 사용량을 불러오지 못했습니다.');
        }

        this.codexAccountUsageLoading = false;
        await this.service.render();
        this.scheduleChartRender();
    }

    public async closeCodexAccountUsage() {
        this.codexAccountUsageOpen = false;
        this.codexAccountUsageLoading = false;
        this.selectedCodexAccount = null;
        await this.service.render();
        this.destroyCharts('codexAccountUsage');
    }

    public codexAccountUsageHours() {
        return this.codexAccountUsageDashboard
            && this.codexAccountUsageDashboard.chart
            && Array.isArray(this.codexAccountUsageDashboard.chart.hours)
            ? this.codexAccountUsageDashboard.chart.hours
            : [];
    }

    public codexAccountUsageSnapshotCountLabel() {
        const totals = this.codexAccountUsageDashboard && this.codexAccountUsageDashboard.totals
            ? this.codexAccountUsageDashboard.totals
            : {};
        return `상태 확인 ${this.dashboardCount(totals.status_hours)}시간 · ${this.dashboardCount(totals.status_snapshots)}건`;
    }

    public codexAccountUsageTickLabel(item: any, index: number, total: number) {
        if (!item) return '';
        if (index === 0 || index === total - 1 || Number(item.hour) === 0) {
            return item.tick_label || String(item.date || '').slice(5);
        }
        return '';
    }

    public codexAccountUsagePercent() {
        const totals = this.codexAccountUsageDashboard && this.codexAccountUsageDashboard.totals
            ? this.codexAccountUsageDashboard.totals
            : {};
        return this.textValue(totals.current_remaining_weekly) || '-';
    }

    public codexAccountUsageChartEmpty() {
        return this.codexAccountUsageHours().every((hour: any) => {
            const hasWeekly = hour && hour.remaining_weekly !== null && hour.remaining_weekly !== undefined;
            return !hasWeekly;
        });
    }

    private scheduleChartRender() {
        if (this.chartRenderTimer) {
            clearTimeout(this.chartRenderTimer);
        }
        this.chartRenderTimer = setTimeout(() => {
            this.chartRenderTimer = null;
            this.renderCharts();
        }, 0);
    }

    private destroyCharts(scope: string = '') {
        Object.keys(this.chartInstances).forEach((key: string) => {
            if (scope && !key.startsWith(scope)) return;
            try {
                this.chartInstances[key].destroy();
            } catch (e) { }
            delete this.chartInstances[key];
        });
    }

    private chartCanvas(id: string) {
        if (typeof document === 'undefined') return null;
        return document.getElementById(id) as HTMLCanvasElement | null;
    }

    private renderCharts() {
        if (this.codexAccountUsageOpen && !this.codexAccountUsageLoading) {
            this.renderCodexAccountUsageChart();
        } else {
            this.destroyCharts('codexAccountUsage');
        }
    }

    private chartPercentValue(value: any) {
        if (value === null || value === undefined || value === '') return null;
        const numberValue = Number(value);
        return Number.isFinite(numberValue) ? Math.max(0, Math.min(100, numberValue)) : null;
    }

    private renderCodexAccountUsageChart() {
        const canvas = this.chartCanvas('accountCodexAccountUsageChart');
        if (!canvas) {
            this.destroyCharts('codexAccountUsage');
            return;
        }
        const rows = this.codexAccountUsageHours();
        const labels = rows.map((item: any) => item.display_label || item.datetime || item.label || String(item.date || '').slice(5));
        const datasets = [
            {
                label: 'weekly 남은 사용량',
                data: rows.map((item: any) => this.chartPercentValue(item && item.remaining_weekly)),
                borderColor: '#4f46e5',
                backgroundColor: this.chartColor('#4f46e5', 0.08),
                borderWidth: 2.2,
                pointRadius: rows.length > 72 ? 0 : (rows.length > 20 ? 2 : 3),
                pointHoverRadius: 4,
                pointBorderWidth: 1.5,
                spanGaps: true,
                tension: 0.32,
                fill: true,
            },
        ];

        this.destroyCharts('codexAccountUsage');
        this.chartInstances.codexAccountUsage = new Chart(canvas, {
            type: 'line',
            data: { labels, datasets },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: { mode: 'index', intersect: false },
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                        labels: { boxWidth: 10, boxHeight: 10, color: '#334155', font: { size: 11, weight: '600' } },
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            title: (items: any[]) => {
                                const index = items && items.length ? items[0].dataIndex : 0;
                                return rows[index] ? rows[index].datetime || rows[index].display_label || rows[index].date : '';
                            },
                            label: (item: any) => {
                                const value = item.raw;
                                return value === null || value === undefined
                                    ? `${item.dataset.label}: -`
                                    : `${item.dataset.label}: ${value}%`;
                            },
                        },
                    },
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: {
                            color: '#64748b',
                            font: { size: 11, weight: '600' },
                            maxRotation: 0,
                            autoSkip: false,
                            callback: (value: any, index: number) => this.codexAccountUsageTickLabel(rows[index], index, rows.length),
                        },
                    },
                    y: {
                        min: 0,
                        max: 100,
                        grid: { color: '#e2e8f0' },
                        ticks: {
                            color: '#64748b',
                            stepSize: 20,
                            callback: (value: any) => `${value}%`,
                        },
                    },
                },
            },
        });
    }

    private chartColor(hex: string, alpha: number) {
        const value = String(hex || '').replace('#', '');
        if (value.length !== 6) return `rgba(15, 23, 42, ${alpha})`;
        const r = parseInt(value.slice(0, 2), 16);
        const g = parseInt(value.slice(2, 4), 16);
        const b = parseInt(value.slice(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    public dashboardScore(value: any) {
        const score = Math.max(0, Math.min(100, Number(value || 0)));
        return score.toLocaleString('ko-KR', { maximumFractionDigits: 1 });
    }

    public dashboardScoreBarWidth(value: any) {
        return `${Math.max(4, Math.min(100, Number(value || 0)))}%`;
    }

    public dashboardCount(value: any) {
        const count = Math.max(0, Number(value || 0));
        return count.toLocaleString('ko-KR');
    }
}

export default PageAccountComponent;